import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Box, Typography, Grid, Pagination, Container, Card, Modal, Button, InputAdornment, TextField, CircularProgress } from '@mui/material';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import LeadService from '../../../core/services/leadsService';
import { Search as SearchIcon, Clear as ClearIcon } from '@mui/icons-material';
import { debounce, throttle } from 'lodash';
import LinearProgress from '@mui/material/LinearProgress';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import toast from 'react-hot-toast';
import { makeStyles } from '@mui/styles';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import { GlobalStyles } from '@mui/system';
import { ThemeProvider } from '@mui/material/styles';
import Slide from '@mui/material/Slide';
import LogoutExpiredModal from '../../LogoutExpiredModal';
import IosShareIcon from '@mui/icons-material/IosShare';
const useStyles = makeStyles((theme) => ({
    textFieldStyleRes: {
        width: '260px',
        [theme.breakpoints.down('md')]: {
            width: '240px',
        },
    },
    tableForSales: {
        [theme.breakpoints.down('md')]: {
            width: '1070px',
        },
        [theme.breakpoints.between('md', 'xmd')]: {
            width: '1150px',
        },
        // [theme.breakpoints.down('lg')]: {
        //     width: '1070px',
        // },
    },
}));
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    width: 'auto',
    height: 'auto',
    overflow: 'auto',
};
const styleConfirm = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '22px',
    width: 'auto',
    height: 'auto',
    overflow: 'auto',
};
const UserType = [
    { value: 'customer', label: 'Customer' },
    { value: 'agent', label: 'Agent' },
];
const SalesUsers = () => {
    const classes = useStyles();
    const theme = useTheme();
    const navigate = useNavigate();
    const [salesUsers, setSalesUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [selectedUserType, setSelectedUserType] = useState('agent');
    const [subscriptionId, setSubscriptionId] = useState('');
    const [logOutModal, setLogOutModal] = useState(false);
    const abortControllerRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [allReadyPayOpen, setAllReadyPayOpen] = useState(false);
    const [sendLoading, setSendLoading] = useState(false);
    const [SubscriptionName, setSubscriptionName] = useState('');
    const [SubscriptionLastName, setSubscriptionLastName] = useState('');
    const handleClose = () => {
        setOpen(false);
    };
    const GetUsersForSale = async (currentPage, searchTerm, selectedUserType, signal, fromDate = '', toDate = '') => {
        try {
            setLoading(true);
            setIsLoading(true)
            const res = await LeadService.GetUsersForSales(currentPage, searchTerm, selectedUserType, signal, fromDate, toDate);
            if (res?.data?.success) {
                setSalesUsers(res?.data?.agents?.data);
                setCurrentPage(res?.data?.agents?.current_page);
                setTotalPages(Math.ceil(res?.data?.agents?.total / res?.data?.agents?.per_page));
            }
        } catch (error) {
            toast.error(error.message);
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setIsLoading(false);
            setLoading(false);
        }
    };

    const HandleSendNotification = async (subscriptionId) => {
        try {
            setSendLoading(true);
            const resp = await LeadService.sendSubscriptionNotification(subscriptionId);
            if (resp?.data?.success) {
                fetchGetUsersForSale(currentPage, searchTerm, selectedUserType);
                setOpen(false);
                toast.success(resp?.data?.message);
            }
        } catch (error) {
            toast.error(error.message);
            if (error.message === 'You have been logged out of the application, please login again to use the application.') {
                setLogOutModal(true);
            } else {
                toast.error(error.message);
            }
        } finally {
            setSendLoading(false);
        }
    };

    const HandleOpenSubsModal = async (id, name, lastName, email) => {
        if (id) {
            const CheckID = id;
            const res = await LeadService.GetUsersCheckSubscription(CheckID);
            if (res?.data?.success) {
                if (res?.data?.agents?.data[0]?.discounted_subscription) {
                    setOpen(true);
                    setSubscriptionId(id);
                    setSubscriptionName(name);
                    setSubscriptionLastName(lastName);
                    return;
                } else {
                    setAllReadyPayOpen(true);
                    return;
                }
            }
        }
    };
    const throttledGetUsersForSale = useCallback(
        throttle((currentPage, searchTerm, selectedUserType, signal) => {
            GetUsersForSale(currentPage, searchTerm, selectedUserType, signal);
        }, 2000),
        []
    );

    // Debounced function to delay the API call until the user stops typing
    const fetchGetUsersForSale = useCallback(
        debounce((currentPage, searchTerm, selectedUserType) => {
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
            }
            const abortController = new AbortController();
            abortControllerRef.current = abortController;
            throttledGetUsersForSale(currentPage, searchTerm, selectedUserType, abortController.signal);
        }, 300),
        [throttledGetUsersForSale]
    );
    useEffect(() => {
        fetchGetUsersForSale(currentPage, searchTerm, selectedUserType);
    }, [currentPage, searchTerm, selectedUserType]);

    const handleCallSaleApi = async () => {
        await fetchGetUsersForSale(currentPage, searchTerm, selectedUserType);
        setAllReadyPayOpen(false);
    };
    const adjustTimeBasedOnOffsetForReceivedDataPaymentsDate = (dateString, offsetInHours) => {
        // Ensure the date string is treated as UTC by appending 'Z'
        const date = new Date(`${dateString}Z`);

        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };
    const adjustTimeBasedOnOffsetForReceivedData = (dateString, offsetInHours) => {
        // Create a date object from the UTC date string
        const date = new Date(dateString);

        // Ensure the date is in UTC by setting the time zone offset
        // Convert date to milliseconds and then adjust by the user offset
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Apply the user offset
        utcDate.setHours(utcDate.getHours() + offsetInHours);

        return utcDate;
    };

    const getUserOffset = () => {
        const offset = localStorage.getItem('userOffset');
        return offset ? parseFloat(offset) : 0;
    };

    const formatDateTime = (date) => {
        const options = { year: 'numeric', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: true };
        return date.toLocaleDateString(undefined, options).replace(',', '');
    };

    const adjustTimeBasedOnOffset = (dateString, offsetInHours) => {
        if (!dateString) throw new Error('Invalid date string');
        const date = new Date(dateString);

        if (isNaN(date)) throw new Error('Invalid date');
        const utcDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);

        // Adjust for offset
        const adjustedDate = new Date(utcDate);
        adjustedDate.setHours(adjustedDate.getHours() + offsetInHours);

        return adjustedDate; // Return Date object for flexibility
    };

    const formatDate = (date) => {
        if (!(date instanceof Date)) throw new Error('Invalid date object');
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const handleSearchClick = async (fromDate, toDate) => {
        try {
            if (!fromDate) return toast.error('Please select the from date.');
            if (!toDate) return toast.error('Please select the to date.');

            const from = new Date(fromDate);
            const to = new Date(toDate);
            if (to < from) return toast.error('Please select a to date later than the start date.');

            const userOffset = getUserOffset();
            const adjustedFrom = adjustTimeBasedOnOffset(fromDate, userOffset);
            const adjustedTo = adjustTimeBasedOnOffset(toDate, userOffset);

            const formattedFrom = formatDate(adjustedFrom);
            const formattedTo = formatDate(adjustedTo);

            // Call fetch function
            GetUsersForSale(1, searchTerm, selectedUserType, '', formattedFrom, formattedTo);
        } catch (error) {
            console.error(error);
            toast.error('An error occurred while processing your dates.');
        }
    };

    const columns = [
        {
            accessorKey: 'id',
            header: 'Sr no',
            size: 40,
            muiTableBodyCellProps: {
                align: 'left',
            },
        },
        {
            accessorKey: 'profile_image',
            header: '',
            Cell: ({ row }) => (
                <div style={{ display: 'flex' }}>
                    <Avatar src={`https://iconnctapp.com/` + row?.original?.profile_image} />
                </div>
            ),
            size: 10,
            enableSorting: false,
        },
        {
            accessorFn: (row) => {
                if (row?.last_name === null) {
                    return row?.name;
                } else {
                    return `${row?.name} ${row?.last_name}`;
                }
            },
            header: 'User Name',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
        },
        {
            accessorKey: 'email',
            header: 'Email ID',
            size: 140,
            // enableClickToCopy: true,
            showColumnFilters: false,
            enableSorting: false,
        },
        {
            accessorKey: 'phone',
            header: 'Phone Number',
            size: 80,
            enableSorting: false,
        },
        {
            accessorKey: 'user_type',
            header: 'User Type',
            size: 80,
            enableSorting: false,
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
            },
        },
        {
            accessorKey: 'trial_start_at',
            header: 'Trail Start',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trial_start_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedDataPaymentsDate(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'trail_end_at',
            header: 'Trail End',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 100,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: 'auto',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.trail_end_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            accessorKey: 'remaining_trial_days',
            header: 'Remaining trial days',
            size: 80,
            enableSorting: false,
        },
        {
            accessorKey: 'created_at',
            header: 'Member Since',
            enableColumnActions: false,
            showColumnFilters: false,
            enableColumnFilter: false,
            enableSorting: false,
            size: 50,
            muiTableHeadCellProps: {
                sx: {
                    fontSize: '14px',
                },
            },
            Cell: ({ row }) => {
                const dateString = row?.original?.created_at;

                if (dateString) {
                    const userOffset = getUserOffset();
                    const adjustedDate = adjustTimeBasedOnOffsetForReceivedData(dateString, userOffset);
                    return <span>{formatDateTime(adjustedDate)}</span>;
                }
                return null;
            },
        },
        {
            header: 'Actions',
            Cell: ({ row }) => {
                const discountSubscription = row?.original?.discounted_subscription;
                const userType = row?.original?.user_type;

                // Ensure condition is correctly checking values
                if (userType === 'agent' && discountSubscription === true) {
                    return (
                        <Button
                            onClick={() =>
                                HandleOpenSubsModal(
                                    row?.original?.id,
                                    row?.original?.name,
                                    row?.original?.last_name,
                                    row?.original?.email
                                )
                            }
                            sx={{
                                width: 'auto',
                                color: '#006FBF',
                                padding: '6px',
                                backgroundColor: '#006FBF0D',
                                border: '1px solid #006FBF',
                                borderRadius: '22px',
                                boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                fontWeight: 'bold',
                            }}
                        >
                            <IosShareIcon />Send Subscription Package Notification
                        </Button>
                    );
                } else if (userType === 'customer') {
                    return <Typography>N/A</Typography>;
                }

                return null;
            },
            muiTableBodyCellProps: {
                align: 'center',
            },
            size: 100,
        }

    ];
    const handleSearchTerm = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };
    const handleClear = () => {
        setSearchTerm('');
    };

    const HandleChangeUserType = (event, newValue) => {
        setSelectedUserType(newValue ? newValue.value : '');
    };
    const handleClearFilter = () => {
        setFromDate(null);
        setToDate(null);
        setSearchTerm('');
        setSelectedUserType('agent');
        fetchGetUsersForSale(1, searchTerm, selectedUserType);
    };

    const filteredColumns = columns.filter(column => {
        if (column.accessorKey === 'trial_start_at' || column.accessorKey === 'trail_end_at' || column.accessorKey === 'remaining_trial_days') {
        return !salesUsers.some(user => user?.user_type === 'customer'); 
        }
        return true;
    });

    return (
        <div>
            <ThemeProvider theme={theme}>
                <GlobalStyles
                    styles={{
                        '::-webkit-scrollbar': {
                            width: '14px', // Set the desired width for the scrollbar
                        },
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: '#c1c1c1', // Set the color for the scrollbar thumb
                            borderRadius: '10px', // Set the border radius for a rounded effect
                        },
                    }}
                />
                <div style={{ marginBottom: '15px' }}> {loading && <LinearProgress />}</div>
                <Box style={{ display: 'Grid', justifyContent: 'center', gap: '20px' }}>
                    <Card
                        sx={{
                            padding: '20px',
                            borderRadius: '22px',
                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                            background: 'white',
                            width: 'auto',
                            transform: 'scale(1)',
                            transition: 'transform 0.3s ease-in-out',
                            marginBottom: '20px',
                        }}
                    >
                        <Box style={{ display: 'grid', gap: '20px' }}>
                            <Box style={{ display: 'flex', gap: '20px' }}>
                            <Box>
                                <Typography sx={{ fontWeight: 'bold' }}>From</Typography>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DateTimePicker
                                            sx={{
                                                overflow: 'hidden',
                                                '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: '#c1c1c1',
                                                },
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '12px',
                                                },
                                            }}
                                            value={fromDate}
                                            onChange={(newDate) => setFromDate(newDate)}
                                            className={classes.textFieldStyleRes}
                                        />
                                    </LocalizationProvider>
                                </Box>
                                <Box>
                                    <div>
                                    <Typography sx={{ fontWeight: 'bold' }}>To</Typography>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                sx={{
                                                    // marginBottom: '200x',
                                                    overflow: 'hidden',
                                                    '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#c1c1c1',
                                                    },
                                                    '.MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
                                                        borderColor: '#c1c1c1',
                                                    },
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '12px',
                                                    },
                                                }}
                                                value={toDate}
                                                onChange={(newDate) => setToDate(newDate)}
                                                className={classes.textFieldStyleRes}
                                            />
                                        </LocalizationProvider>
                                    </div>
                                </Box>
                                <Box style={{ display: 'flex', gap: '5px', marginTop:'25px' }}>
                                    <Button
                                        variant="contained"
                                        sx={{
                                            cursor: 'pointer',
                                            borderRadius: '12px',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            fontWeight: 'bold',
                                            height: '40px',
                                            marginTop: '6px',
                                            background: '#5379BD',
                                            fontFamily: 'inherit',
                                        }}
                                        onClick={() => handleSearchClick(fromDate, toDate)}
                                    >
                                        {' '}
                                        Search By Date
                                    </Button>
                                    <Button
                                        style={{
                                            width: '30px',
                                            height: '39px',
                                            border: '1px solid gray',
                                            background: '#bababa',
                                            borderRadius: '12px',
                                            fontWeight: 'bold',
                                            marginLeft: '0px',
                                            cursor: 'pointer',
                                            marginTop: '6px',
                                            color: 'black',
                                        }}
                                        sx={{ fontFamily: 'inherit' }}
                                        onClick={handleClearFilter}
                                    >
                                        Clear
                                    </Button>
                                </Box>
                            </Box>
                            <Box style={{ display: 'flex', gap: '20px' }}>
                                <Autocomplete
                                    options={UserType}
                                    getOptionLabel={(UserType) => UserType.label}
                                    renderInput={(params) => <TextField {...params} label="User Type" />}
                                    value={UserType?.find((UserType) => UserType?.value === selectedUserType) || null}
                                    onChange={HandleChangeUserType}
                                    disabled={isLoading}
                                    sx={{
                                        width: 260,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                />
                                <TextField
                                    value={searchTerm}
                                    onChange={handleSearchTerm}
                                    sx={{
                                        width: 260,
                                        '& .MuiOutlinedInput-root': {
                                            borderRadius: '12px',
                                        },
                                    }}
                                    placeholder="Search by name & email"
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <SearchIcon />
                                            </InputAdornment>
                                        ),
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton onClick={handleClear} aria-label="clear search">
                                                    <ClearIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                    }}
                                    variant="outlined"
                                />

                            </Box>
                        </Box>
                    </Card>
                </Box >
                <Box className={classes.tableForSales}>
                    <Card style={{ borderRadius: '22px', boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px' }}>
                        <MaterialReactTable
                            columns={filteredColumns}
                            data={salesUsers}
                            state={{ isLoading: isLoading }}
                            muiCircularProgressProps={{
                                color: 'secondary',
                                thickness: 5,
                                size: 55,
                            }}
                            muiSkeletonProps={{
                                animation: 'pulse',
                                height: 28,
                            }}
                            enableTopToolbar={false}
                            enableFacetedValues={true}
                            enableStickyHeader={true}
                            enableDensityToggle={false}
                            enableHiding={false}
                            showSkeletons={false}
                            enableColumnFilterModes={false}
                            enableColumnActions={false}
                            enableColumnOrdering={false}
                            enableFullScreenToggle={false}
                            enableColumnFilters={false}
                            enablePagination={false}
                            getRowId={(row) => row.id}
                            initialState={{
                                showColumnFilters: false,
                                showGlobalFilter: false,
                            }}
                            muiTableBodyRowProps={{
                                sx: {
                                    backgroundColor: '#f5f5f5', // Default row background color
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: '#ffffff', // Alternate rows with white
                                    },
                                    '&:hover': {
                                        backgroundColor: '#e0e0e0', // Hover effect
                                        cursor: 'pointer',
                                    },
                                },
                            }}
                        />
                    </Card>
                    <Pagination
                        count={totalPages}
                        color="primary"
                        page={currentPage}
                        onChange={(event, value) => setCurrentPage(value)}
                        style={{ marginTop: '-40px', zIndex: 1000, position: 'relative', display: 'flex', justifyContent: 'flex-end' }}
                    />
                </Box>
                {/* send notification */}
                <Modal open={open} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <div>
                            <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Confirmation</Typography>
                        </div>
                        <div style={{ marginTop: '10px', position: 'relative' }}>
                            <Box
                                sx={{
                                    display: 'grid',
                                    padding: '10px',
                                    gap: '10px',
                                }}
                            >
                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                    <Typography>
                                        Are you sure you want to send this subscription notification to
                                        <span style={{ color: 'blue' }}>
                                            {' '}
                                            {SubscriptionName} {SubscriptionLastName}
                                        </span>
                                        ?
                                    </Typography>{' '}
                                </Box>
                            </Box>
                            <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                                <Button onClick={handleClose}>NO</Button>
                                <Button onClick={() => HandleSendNotification(subscriptionId)} disabled={sendLoading}>
                                    {' '}
                                    {sendLoading ? 'Processing...' : 'YES'}
                                </Button>
                            </Box>
                        </div>
                    </Box>
                </Modal>
                {/* all ready send notification */}
                <Modal open={allReadyPayOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                    <Box sx={styleConfirm}>
                        <div>
                            <Typography style={{ fontWeight: 'bold', fontSize: '18px' }}>Note</Typography>
                        </div>
                        <div style={{ marginTop: '10px', position: 'relative' }}>
                            <Box
                                sx={{
                                    display: 'grid',
                                    padding: '10px',
                                    gap: '10px',
                                }}
                            >
                                <Box style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                                    <Typography>
                                        Agent can already avail this offer.
                                        <span style={{ color: 'blue' }}>
                                            {' '}
                                            {SubscriptionName} {SubscriptionLastName}
                                        </span>
                                    </Typography>{' '}
                                </Box>
                            </Box>
                            <Box style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                                <Button onClick={handleCallSaleApi}>OK</Button>
                            </Box>
                        </div>
                    </Box>
                </Modal>
                <LogoutExpiredModal setLogOutModal={setLogOutModal} logOutModal={logOutModal} />
            </ThemeProvider>
        </div >

    );
};

export default SalesUsers;
